import apiService from '@sonifi/wb-core/services/api.service';
import {
  setProducts,
  setProductsSettings,
} from '../store/productsSlice';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { GROUPS_KEYS } from '@sonifi/wb-group/store/groupsConstants';
import { parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';

export const getProducts = () => async (dispatch) => {
  const queryParams = parseQueryParams({ enabled: true, rpp: -1 });
  const url = `${ENDPOINTS.PRODUCTS}?${queryParams}`;
  const {
    data: { objects: products },
  } = await apiService.get(url);
  dispatch(setProducts(products));
};

export const getProductById = (id) => (_, getState) => {
  const {
    products: { products },
  } = getState();

  return products.find((product) => product.id === id);
};

export const getProductsSettings = (groupId) => async (dispatch, getState) => {
  try {
    const {
      groups: { groups },
    } = getState();
    const group = groups[GROUPS_KEYS.allGroups].find(
      (g) => g.id === parseInt(groupId),
    );
    const url = `${ENDPOINTS.PRODUCT_SETTINGS}?group=${group.uri}`;
    const {
      data: { objects: productsSettings, _embedded },
    } = await apiService.get(url);
    const settings = productsSettings.map((p) => ({ ...p, group }));
    await dispatch(
      setProductsSettings({ [group.id]: { settings, _embedded } }),
    );
    const { products: currentProducts } = getState();
    return currentProducts.productsSettings[groupId];
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getSettingByProduct =
  ({ groupId, productKey }) =>
  (dispatch, getState) => {
    const product = dispatch(getProductById(productKey));
    const {
      products: { productsSettings },
    } = getState();
    const settings = Object.values(productsSettings[groupId]?.settings || {}).find(
      (ps) => ps.product === product.uri,
    );
    return settings;
  };
